/* globals _ */

import api from './api';

const { noop } = _;

export default function( placeid, callback ) {
	callback = callback || noop;

	api( 'google/place/details', { placeid }, response => {
		callback( response.result, response.status );
	} );
}
